import {Spinner} from '@components/ui/spinner'
import {useTranslation} from '@/translations/i18n'
import {Navigate} from 'react-router'
import {routes} from '@utilities/constants/routes'
import {useEffect} from 'react'
import {useConfirmEmailRequest} from '@features/settings/queries/useConfirmEmailRequest'
import {errorHandler, raise} from '@utilities/helpers'
import {useParams} from 'react-router-dom'
import {toast} from '@utilities/toast'

export const ChangeEmailVerify = () => {
    const {t} = useTranslation()
    const params = useParams()
    const token = params.token ?? raise('token is nullish')
    const {isSuccess, isError, isPending, data, error} = useConfirmEmailRequest(token)

    useEffect(() => {
        if (isSuccess) {
            toast.success(
                <div>
                    <h3 className="text-sm font-medium">
                        {t('settings:personal_information:email_address_verified', {email: data?.email})}
                    </h3>
                    <p className="text-sm text-neutral-700">{t('settings:personal_information:sign_in_again')}</p>
                </div>
            )
        }
    }, [isSuccess])

    useEffect(() => {
        if (isError) {
            errorHandler(error)
        }
    }, [isError])

    if (isPending)
        return (
            <div className="flex flex-col items-center justify-center h-full w-full p-4 bg-white md:p-8 gap-6">
                <Spinner size={40} />
            </div>
        )

    if (isSuccess || isError) return <Navigate to={routes.LOGIN.handle.fullPath} />
}
